"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var sortData = function sortData(data, columns, _ref) {
  var key = _ref.key,
      reverse = _ref.reverse;
  if (!key) return data;

  var _columns$find = columns.find(function (col) {
    return col.key === key;
  }),
      sortFn = _columns$find.sortFn;

  if (!(0, _isFunction.default)(sortFn)) return data;
  var sortedData = data.sort(sortFn);
  return reverse ? (0, _toConsumableArray2.default)(sortedData).reverse() : sortedData;
};

var _default = sortData;
exports.default = _default;